<template>
    <div class="wrapper consume-wrapper">
        <div class="header">
            <BaseHeader :title="'提现记录'"/>
        </div>
        <div class="search-date">
            <TheSearchByDate :total="total" @handleChangeDate="handleChangeDate"/>
        </div>
        <div class="content ">
            <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getData">
                <div class="consume-item" v-for="item in cashList" :key="item.id">
                    <div>
                        <p class="timer">{{item.created_at}}</p>
                        <p class="title">
                            <span v-if="item.pay_type === 0">提现到微信</span>
                            <span v-else>提现到支付宝</span>
                        </p>
                    </div>
                    <div class="price">
                        +{{item.amount}}
                    </div>
                </div>
            </van-list>
        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex';
    import BaseHeader from "../components/BaseHeader";
    import {getSaleRecordsListService} from "../service/salesmanService";
    import {Toast} from 'vant';
    import TheSearchByDate from "../components/TheSearchByDate";
	//import {wecharShare} from "../util/weChat.js";

    export default {
        name: "SalesmanCashList",
        data(){
            return{
                cashList:[],
                loading: false,
                finished: false,
                offset:{
                    page:0,
                    limit:10,
                },
                total:0,//总计
                temp:0,
            }
        },
		mounted() {
			//wecharShare(location.href.split('#')[0],location.href.split('#')[1]);
		},
        methods:{

            //改变筛选条件
            handleChangeDate(startDate,endDate){
                this.startDate = startDate;
                this.endDate = endDate;
                this.total = 0;
                this.offset.page = 0;
                this.cashList = [];
                // this.temp = 2;
                this.loading = false;
                this.finished = false;
                if(sessionStorage.getItem('t_s_s') && sessionStorage.getItem('t_s_s') === 'yes'){
                    this.getData();
                    sessionStorage.removeItem('t_s_s')
                }

            },

            //获取数据
            getData(){
                this.offset.page++;
                getSaleRecordsListService(this.saleId,this.offset.page,this.offset.limit,this.startDate,this.endDate).then(res => {
                    if(res.status === 1){
                        this.loading = false;
                        if(res.datas.datas.length === 0){
                            this.finished = true;
                            return;
                        }
                        if(res.datas.datas.length > 0){
                            this.total = res.datas.sum_num;
                        }
                        this.cashList = [... this.cashList,...res.datas.datas];
                    }else{
                        Toast(res.msg);
                    }
                }).catch(err => {
                    console.log(err);
                }).finally(() => {
                    // console.log(1)
                })
            },
        },
        computed:{
            ...mapState({
                saleId: state => state.userInfo.saleId,
            })
        },
        components:{
            BaseHeader,
            TheSearchByDate
        }
    }
</script>

<style lang="scss">
    .consume-wrapper{
        background: #ffffff!important;
        .content{
            padding: 20px 15px;
            box-sizing: border-box;
            background: #ffffff!important;
            .consume-item{
                background: #ffffff;
                padding: 15px 10px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                &:not(:last-child){
                    border-bottom: 1px solid rgba(240,240,240,1);
                }
                .title{
                    color: #202020;
                    font-size: 14px;
                    margin-top: 5px;
                }
                .price{
                    color: #EF000C;
                    font-size: 14px;
                }
            }
        }

    }
</style>
<style scoped>
    .van-cell{
        background: #ffffff;
    }
</style>